/****************************************************
 * Module Name:  userProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import restAPICall from "./../../api/restAPICall";
import Constants from "./../../constants";

export default class UserProxy {
  static Validate = (user, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/user/validate",
      "post",
      undefined,
      undefined,
      JSON.stringify(user),
      "application/json",
      0,
      true
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetAllUser = (callback) => {
    let params = {
      specialuser: "",
    };
    restAPICall(
      Constants.MANAGER_URL + "/user",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetAllSpecialUser = (callback) => {
    let params = {
      specialuser: true,
    };
    restAPICall(
      Constants.MANAGER_URL + "/user",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetAllGenericUser = (callback) => {
    let params = {
      specialuser: false,
    };
    restAPICall(
      Constants.MANAGER_URL + "/user",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetAllUserDetail = (userid, callback) => {
    // will fetch customer and broker of the employee 
    restAPICall(
      Constants.MANAGER_URL + `/user/alldetail/employee/${userid}`,
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetAllFieldsUserDetailByUserid = (userid, callback) => {
    // will fetch single users details
    restAPICall(
      Constants.MANAGER_URL + `/user/alldetail/user/${userid}`,
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetAllSpecialUserDetail = (callback) => {
    let params = {
      specialuser: true,
    };
    restAPICall(
      Constants.MANAGER_URL + "/user/detail",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetAllGenericUserDetail = (callback) => {
    let params = {
      specialuser: false,
    };
    restAPICall(
      Constants.MANAGER_URL + "/user/detail",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetSpecificBrokerCustomerMini = (brokerId, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/user/detail/broker/" + brokerId + "/customer/mini",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  }

  static GetSpecificBrokerCustomerMiniByPermission = (brokerId, permission, callback) => {
    let params = { permission: permission };
    restAPICall(
      Constants.MANAGER_URL + "/user/detail/broker/" + brokerId + "/customer/mini",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  }

  static GetSpecificEmployeesCustomerMini = (employeeId, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/user/detail/employee/" + employeeId + "/customer/mini",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  }

  static GetSpecificEmployeesCustomerMiniByPermission = (employeeId, permission, callback) => {
    let params = { permission: permission };
    restAPICall(
      Constants.MANAGER_URL + "/user/detail/employee/" + employeeId + "/customer/mini",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  }

  static getAllCustomerMappedEmployeeMini = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/user/customer/mini/mappedtoemployee",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  }

  static GetAllUserDetailEmployee = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/user/detail/employee",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetAllEmployeeMini = (designation, callback) => { //pass comma seprated designations
    let params = {
      designation: designation,
    };
    restAPICall(
      Constants.MANAGER_URL + "/user/employee/mini",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetAllActiveEmployeeMini = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/user/employee/active/mini",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetAllBrokerMini = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/user/broker/mini",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetAllCustomerMini = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/user/customer/mini",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetAllUserDetailBroker = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/user/detail/broker",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetAllUserDetailCustomer = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/user/detail/customer",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetAllUserMini = (callback) => {
    let params = {
      specialuser: "",
    };
    restAPICall(
      Constants.MANAGER_URL + "/user/mini",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };
  static GetAllSpecialUserMini = (callback) => {
    let params = {
      specialuser: true,
    };
    restAPICall(
      Constants.MANAGER_URL + "/user/mini",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };
  static GetAllGenericUserMini = (callback) => {
    let params = {
      specialuser: false,
    };
    restAPICall(
      Constants.MANAGER_URL + "/user/mini",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetSingleUser = (userId, callback) => {
    let params = {
      id: userId,
    };

    restAPICall(
      Constants.MANAGER_URL + "/user",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetUserDetail = (userIds, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/user/detail",
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(userIds),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetSingleUsersAllBrokerAndCustomer = (userId, callback) => {
    let params = {
      id: userId,
    };

    restAPICall(
      Constants.MANAGER_URL + "/user/allcustomerbroker",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetSingleUserDetail = (userId, callback) => {
    let params = {
      id: userId,
    };

    restAPICall(
      Constants.MANAGER_URL + "/user/detail",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetSingleUserByUserName = (userName, userToken, callback) => {
    let params = {
      username: userName,
    };

    if (userToken === undefined || userToken === null || userToken === "")
      userToken = Constants.userToken;

    restAPICall(
      Constants.MANAGER_URL + "/user",
      "get",
      userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetMultipleUsers = (users, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/user/multiple",
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(users),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetMultipleUsersMappedEmployee = (users, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/user/multiple/customer",
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(users),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetAllUserExcept = (users, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/user/except",
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(users),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetAllUserExceptMini = (users, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/user/except/mini",
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(users),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static UsersThatAreNotDeptHeads = (callback) => {
    let params = {
      specialuser: false,
    };

    restAPICall(
      Constants.MANAGER_URL + "/user/nodepartment/mini",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static UsersThatAreNotDeptGroupHeads = (callback) => {
    let params = {
      specialuser: false,
    };

    restAPICall(
      Constants.MANAGER_URL + "/user/nodepartmentgroup/mini",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static CheckUserNameAvailable = (userName, callback) => {
    let params = {
      username: userName,
    };

    restAPICall(
      Constants.MANAGER_URL + "/user/available",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static CheckIsUserHead = (userId, callback) => {
    let params = {
      id: userId,
    };

    restAPICall(
      Constants.MANAGER_URL + "/user/validatehead",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetUserTree = (userId, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/user/" + userId,
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static AddUser = (user, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/user",
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(user),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static UpdateUser = (user, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/user",
      "put",
      Constants.userToken,
      undefined,
      JSON.stringify(user),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static AddUserAndProfileDetails = (user, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/user/alldetails",
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(user),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static UpdateUserAndProfileDetails = (user, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/user/alldetails",
      "put",
      Constants.userToken,
      undefined,
      JSON.stringify(user),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static UpdateUserAndProfileDetailsByExcel = (user, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/user/alldetails/excel",
      "put",
      Constants.userToken,
      undefined,
      JSON.stringify(user),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static AddUserAndProfileDetailsByExcel = (user, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/user/alldetails/excel",
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(user),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static UpdatePassword = (user, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/user/password",
      "put",
      Constants.userToken,
      undefined,
      JSON.stringify(user),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static UserReport = (userType, locationId, disabled, deleted, callback) => {
    let params = {
      disabled: disabled,
      deleted: deleted,
    };
    restAPICall(
      Constants.MANAGER_URL + `/user/${userType}/${locationId}`,
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static UpdateUserKyc = (userid, approve, callback) => {
    let params = {
      approve: approve
    }
    restAPICall(
      Constants.MANAGER_URL + `/user/kyc/${userid}`,
      "put",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetKycByUserid = (userid, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/user/kyc/${userid}`,
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static UserReportDetails = (user, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/user/utype/mini`,
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(user),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static ForgotPassword = (username, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/user/forgotpassword/${username}`,
      "get",
      undefined,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static ResetPassword = (username, password, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/user/setpassword/${username}/${password}`,
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static signUp = (newUser, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/user/signup",
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(newUser),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static checkUserEmailAvailable = (email, callback) => {
    let params = {
      email: email,
    };

    restAPICall(
      Constants.MANAGER_URL + "/user/available/email",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  }

  static checkUserEmailAvailableForUser = (userid, email, callback) => {
    let params = {
      userid: userid,
      email: email,
    };

    restAPICall(
      Constants.MANAGER_URL + "/user/available/email",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  }

  static GetAllUserCustomerMiniByLocation = (locationid, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/user/customer/mini/${locationid}`,
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static EditUserDetails = (data, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/user/manageprofile",
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0,
      true
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static UpdateUserAndProfileDetails = (user, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/user/alldetails",
      "put",
      Constants.userToken,
      undefined,
      JSON.stringify(user),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  //this type of stone buyed from our system by what all customers 
  static GetStonePotentialBuyerForStone = (stoneid, data, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/user/fetch/potential/mappeduser/stone/${stoneid}`,
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetBrokerCommissionByStonetype = (brokerid, natural, callback) => {
    let params = {
      natural: natural,
    };
    restAPICall(
      Constants.MANAGER_URL + `/user/broker/commission/${brokerid}`,
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  }
}
